import {
  collectionMessage as sharedCollectionMessage,
  type CollectionMessageEntry,
} from '@aeris/status-meta'

import { formatDate } from './date-format.ts'

/**
 * O texto da cobrança pelo WhatsApp do celular (F135). A regra mora em
 * `@aeris/status-meta` desde a F310, para o app do celular escrever a mesma
 * mensagem; aqui a data sai no fuso do navegador, como no resto do site.
 */
export type { CollectionMessageEntry }

export const collectionMessage = (input: {
  readonly customerName: string
  readonly companyName: string
  readonly entries: readonly CollectionMessageEntry[]
  readonly total: string
}): string => sharedCollectionMessage({ ...input, formatDate })
